export default __webpack_public_path__ + "static/media/juegoconstancias_ganar.9af7bc1f.png";